var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-found"},[_c('img',{attrs:{"src":_vm.warnImg,"alt":"icone de alerta"}}),_c('h2',[_vm._v("Não há dados para serem exibidos")]),_c('p',[_vm._v("Atualize os filtros para mostrar dados.")])])}
var staticRenderFns = []

export { render, staticRenderFns }